import { ResponsiveBar } from "@nivo/bar";
import moment from "moment";
import { useEffect, useState } from "react";
import fetchVisitsAll from "../../../services/fetchVisistsAll";
import fetchVisitsAllOut from "../../../services/fetchVisistsAllOut";
import fetchWipBooked from "../../../services/fetchWipBooked";

const SideChart = () => {
  const [startDate, setStateDate] = useState(
    moment(new Date()).format("YYYYMMDD")
  );
  const [endDate, setEndDate] = useState(moment(new Date()).format("YYYYMMDD"));
  const [vehiclesArrived, setVehiclesArrived] = useState(0);
  const [vehiclesExited, setVehiclesExited] = useState(0);
  const [vehiclesBooked, setVehiclesBooked] = useState(0);
  const [isLoading, setLoading] = useState(false);
  const site_id = "6224dcf60c5c49d9fec9218f";

  const handleFetchVehiclesArrived = async () => {
    setLoading(true);
    const data = await fetchVisitsAll(site_id);
    setVehiclesArrived(data?.length);
    setLoading(false);
  };

  const handleFetchVehiclesExited = async () => {
    setLoading(true);
    const data = await fetchVisitsAllOut(site_id);
    setVehiclesExited(data?.length);
    setLoading(false);
  };

  const handleFetchVehiclesBooked = async () => {
    setLoading(true);
    const data = await fetchWipBooked(startDate, endDate);
    setVehiclesBooked(data?.length);
    setLoading(false);
  };

  useEffect(() => {
    handleFetchVehiclesArrived();
    handleFetchVehiclesExited();
    handleFetchVehiclesBooked();
  }, []);

  const booked = vehiclesBooked;
  const arrived = vehiclesArrived;
  const exited = vehiclesExited;
  const stayed = arrived - exited;

  const data = [
    {
      Booked: booked,
      BookedColor: "hsl(75, 70%, 50%)",
      Arrived: arrived,
      ArrivedColor: "hsl(70, 70%, 50%)",
      Exited: exited,
      ExitedColor: "hsl(176, 70%, 50%)",
      Stayed: stayed,
      VisitedColor: "hsl(137, 70%, 50%)",
    },
  ];

  return (
    <ResponsiveBar
      data={data}
      keys={["Booked", "Arrived", "Exited", "Stayed"]}
      indexBy="country"
      margin={{ top: 50, right: 130, bottom: 50, left: 60 }}
      padding={0.3}
      groupMode="grouped"
      valueScale={{ type: "linear" }}
      indexScale={{ type: "band", round: true }}
      colors={{ scheme: "nivo" }}
      defs={[
        {
          id: "dots",
          type: "patternDots",
          background: "inherit",
          color: "#38bcb2",
          size: 4,
          padding: 1,
          stagger: true,
        },
        {
          id: "lines",
          type: "patternLines",
          background: "inherit",
          color: "#eed312",
          rotation: -45,
          lineWidth: 6,
          spacing: 10,
        },
      ]}
      fill={[
        {
          match: {
            id: "fries",
          },
          id: "dots",
        },
        {
          match: {
            id: "sandwich",
          },
          id: "lines",
        },
      ]}
      borderColor={{
        from: "color",
        modifiers: [["darker", 1.6]],
      }}
      axisTop={null}
      axisRight={null}
      axisBottom={{
        tickSize: 5,
        tickPadding: 5,
        tickRotation: 0,
        legend: "Analysis",
        legendPosition: "middle",
        legendOffset: 32,
      }}
      axisLeft={{
        tickSize: 5,
        tickPadding: 5,
        tickRotation: 0,
        legend: "Vehicles",
        legendPosition: "middle",
        legendOffset: -40,
      }}
      labelSkipWidth={12}
      labelSkipHeight={12}
      labelTextColor={{
        from: "color",
        modifiers: [["darker", 1.6]],
      }}
      legends={[
        {
          dataFrom: "keys",
          anchor: "bottom-right",
          direction: "column",
          justify: false,
          translateX: 120,
          translateY: 0,
          itemsSpacing: 2,
          itemWidth: 100,
          itemHeight: 20,
          itemDirection: "left-to-right",
          itemOpacity: 0.85,
          symbolSize: 20,
          effects: [
            {
              on: "hover",
              style: {
                itemOpacity: 1,
              },
            },
          ],
        },
      ]}
      role="application"
      ariaLabel="Vehicle Statistics"
      barAriaLabel={function (e: any) {
        return e.id + ": " + e.formattedValue + " - " + e.indexValue;
      }}
    />
  );
};

export default SideChart;
